import { html, ViewTemplate, repeat, ref, when } from '@microsoft/fast-element';
import type { MyProjectsContainer } from './my-projects';
import { eventDetail } from '../../../../utils/formatting';

export const MyProjectsContainerTemplate: ViewTemplate<MyProjectsContainer> = html`
  <div class="container">
    <div class="container-header">
      <h3 class="container-title my-projects-padding">My Projects</h3>
      <div class="container-buttons">
        <slot name="buttons"></slot>
      </div>
    </div>
    <zero-tabs class="top-level" ${ref('modalTabs')}>
      <zero-tab>Projects</zero-tab>
      <zero-tab>Draft Projects</zero-tab>
      <zero-tab-panel>
        <div class=${x => x.isProjectListEmpty() ? 'no-project-listed' : 'project-list'}>
        ${when(x => x.isProjectListEmpty(), html`
            <div>No Projects Listed</div>
          `)}
          ${when(x => !x.isProjectListEmpty(), html`
            ${repeat(
              (x, c) => x.projectList,
              html`
                <project-vppa-card
                  id="${(x, c) => 'projectCard'+x.PROJECT_ID}"
                  :isSelected=${(x, c) =>
                    c.parent.selectedProject && x.PROJECT_ID === c.parent.selectedProject.PROJECT_ID
                      ? true
                      : false}
                  :project=${(x) => x}
                  @selectedProject="${(x, c) => c.parent.toggleSelectProject(x)}"
                ></project-vppa-card>
                <zero-tooltip
                    anchor="${(x, c) => 'projectCard'+x.PROJECT_ID}"
                    position="top"
                >
                  Click here to select a Project to enter a Contract
                </zero-tooltip>
              `
            )}
          `)}
        </div>
      </zero-tab-panel>
      <zero-tab-panel>
        <div class="draft-project-list my-projects-padding">
          ${repeat(
            (x, c) => x.draftProjectList,
            html`
              <project-card :project=${(x) => x} :isDraftProject=${() => true}></project-card>
            `
          )}
        </div>
      </zero-tab-panel>
    </zero-tabs>
  </div>
`;
